'use strict';
/* FIXME: Remove */
function CompanyGuestKeypassesCtrl() {
}

angular.module('dokiv')
  .controller('CompanyGuestKeypassesCtrl', [CompanyGuestKeypassesCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/keypasses/CompanyGuestKeypassesCtrl.js
// module id = 292
// module chunks = 0